import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="indicacion-medica-tabulado"
export default class extends Controller {
  static targets = [
    "tipoIndicacion",
    "parenteralFields",
    "farmacologicaFields",
    "enteralFields",
    "viaAsignacionSelect",
    "viaOption",
    "tipoSelect",
    "tipoOption",
    "velocidadSelect",
    "velocidadOption",
    "unidadSelect",
    "unidadOption",
    "cantidadLabel",
    "cantidadInput",
    "agregadosContainer",
    "nutricionFields",
    "tiposNutricion",
    "frecuenciaSelect",
    "otraFields",
    "indicacionTexto",
    "farmacoCodigo"
  ]

  connect() {
    this.toggleFields()
  }

  toggleFields() {
    const selectedType = this.tipoIndicacionTarget.value

    this.parenteralFieldsTargets.forEach(el => el.classList.add("d-none"))
    this.farmacologicaFieldsTargets.forEach(el => el.classList.add("d-none"))
    this.enteralFieldsTargets.forEach(el => el.classList.add("d-none"))
    this.nutricionFieldsTargets.forEach(el => el.classList.add("d-none"))
    this.otraFieldsTargets.forEach(el => el.classList.add("d-none"))

    switch (selectedType) {
      case "parenteral":
        this.parenteralFieldsTargets.forEach(el => el.classList.remove("d-none"))
        break
      case "farmacologica":
        this.farmacologicaFieldsTargets.forEach(el => el.classList.remove("d-none"))
        break
      case "enteral":
        this.enteralFieldsTargets.forEach(el => el.classList.remove("d-none"))
        break
      case "nutricion":
        this.nutricionFieldsTargets.forEach(el => el.classList.remove("d-none"))
        break
      case "otra":
        this.otraFieldsTargets.forEach(el => el.classList.remove("d-none"))
        break
      default:
        break
    }

    this.filterOptions(this.viaAsignacionSelectTarget, this.viaOptionTargets, selectedType)
    this.filterOptions(this.tipoSelectTarget, this.tipoOptionTargets, selectedType)
    this.filterOptions(this.velocidadSelectTarget, this.velocidadOptionTargets, selectedType)
    this.filterOptions(this.unidadSelectTarget, this.unidadOptionTargets, selectedType)
    this.updateCantidadLabel(selectedType)
    this.toggleAgregados(selectedType)
    this.toggleDisabled(this.tiposNutricionTargets, selectedType === "nutricion")
    this.toggleDisabled(this.frecuenciaSelectTargets, ["farmacologica", "otra"].includes(selectedType))
    this.toggleDisabled(this.indicacionTextoTargets, selectedType === "otra")
  }

  changeTipo() {
    this.clearFields()
    this.toggleFields()
  }

  clearFields() {
    this.element.querySelectorAll("input, select, textarea").forEach(el => {
      if (el === this.tipoIndicacionTarget || el.closest("[data-keep-on-tipo-change]")) return
      if (el.type === "hidden" && el.dataset.autocompleteTarget !== "hidden") return

      if (el.type === "checkbox" || el.type === "radio") {
        el.checked = false
      } else if (el.tomselect) {
        el.tomselect.clear(true)
      } else {
        el.value = ""
      }
    })

    const observaciones = this.element.closest("form")?.querySelector('textarea[name$="[Observaciones]"]')
    if (observaciones && !observaciones.readOnly) observaciones.value = ""

    this.setNow("#indicacion-medica-detalle-fecha-input", this.formatDate(new Date()))
    this.setNow("#indicacion-medica-detalle-hora-input", this.formatTime(new Date()))
  }

  setNow(selector, value) {
    const input = this.element.querySelector(selector)
    if (!input || input.disabled) return

    input.value = value
    input.dispatchEvent(new Event("change", { bubbles: true }))
    input.dispatchEvent(new Event("input", { bubbles: true }))
  }

  formatDate(date) {
    const pad = n => String(n).padStart(2, "0")
    return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`
  }

  formatTime(date) {
    const pad = n => String(n).padStart(2, "0")
    return `${pad(date.getHours())}:${pad(date.getMinutes())}`
  }

  clearFarmaco() {
    if (!this.hasFarmacoCodigoTarget || this.farmacoCodigoTarget.value === "") return

    this.farmacoCodigoTarget.value = ""
    this.farmacoCodigoTarget.dispatchEvent(new Event("input"))
  }

  toggleDisabled(elements, enabled) {
    elements.forEach(el => {
      if (el.dataset.locked === "true") return

      if (el.tomselect) {
        enabled ? el.tomselect.enable() : el.tomselect.disable()
      } else {
        el.disabled = !enabled
      }
    })
  }

  toggleAgregados(selectedType) {
    if (!this.hasAgregadosContainerTarget) return

    const enabled = selectedType === "parenteral"
    this.agregadosContainerTarget.querySelectorAll("input, select").forEach(el => { if (el.dataset.agregadosLocked === "true") return; el.disabled = !enabled })
  }

  filterOptions(select, optionTargets, selectedType) {
    const currentValue = select.value || select.dataset.initialValue || ""
    delete select.dataset.initialValue

    while (select.options.length > 0) {
      select.remove(0)
    }

    const promptOption = optionTargets.find(option => option.dataset.isPrompt === "true")
    if (promptOption) {
      select.add(promptOption.cloneNode(true))
    }

    optionTargets.forEach(option => {
      if (option.dataset.isPrompt === "true") {
        return
      }

      const allowedTypes = option.dataset.allowedTypes ? option.dataset.allowedTypes.split(",") : []

      if (allowedTypes.includes(selectedType) || allowedTypes.length === 0) {
        select.add(option.cloneNode(true))
      }
    })

    if (Array.from(select.options).some(opt => opt.value === currentValue)) {
      select.value = currentValue
    } else {
      select.value = ""
    }
  }

  updateCantidadLabel(selectedType) {
    let newLabelText = "Dosis/Cantidad"
    let newPlaceholderText = "Dosis/Cantidad"

    if (selectedType === "enteral") {
      newLabelText = "Infusión"
      newPlaceholderText = "Infusión"
    }

    this.cantidadLabelTarget.textContent = newLabelText
    this.cantidadInputTarget.placeholder = newPlaceholderText
  }
}
